
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon, Notification, Sidepanel, DataTable, ButtonIcon, TabsNavigation, Tab, Breadcrumb, Popover, Modal, TextArea, Switcher } from "pepsico-ds";
import "./active-directory.css";
import axios from "axios";
import { useLoading } from "../../loader";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import serviceUnavailable from "../../assets/error-screens/pam_no_data_found.svg";
import { toast, ToastContainer } from 'react-toastify';
import activeDirectoryService from "./activa-directory.service";
import { useUserProfile } from "../../common/user_profile_context";

const ActiveDirectory = () => {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language?.split("_")?.[0] === "ar";
    const { userProfile } = useUserProfile();  
    const navigate = useNavigate();
    const { REACT_APP_API_ENDPOINT } = process.env;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [accountData, setAccountData] = useState([]);
    const [selectedGroupMemberships, setSelectedGroupMemberships] = useState([]);
    const [selectedAccountID, setSelectedAccountID] = useState("");
    const { showLoader, hideLoader } = useLoading();
    const [loader, setLoader] = useState(false);
    const [showSidePanel, setShowSidePanel] = useState(false);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [showRiskySidepanel, setShowRiskySidepanel] = useState(false);
    const [actionPopoverID, setActionPopoverID] = useState("");
    const actionPopoverIDRef = useRef("")
    const accountDataRef = useRef([]);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [showModal, setShowModal] = useState(false);
    const [requestData, setRequestData] = useState(null);
    const [copyButtonText, setCopyButtonText] = useState(t('nonArExtension.copy'));
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [showPolicyModal, setShowPolicyModal] = useState(false);
    const [isExceptionPolicyModal, setIsExceptionPolicyModal] = useState(false);
    const [businessJustification, setBusinessJustification] = useState("");
    const [selectedTypeTabIndex, setSelectedTypeTabIndex] = useState(0);
    const groupMembershipsColumns = [
        { columnKey: "domain", header: t("active_directory.domain"), showColumnVisibility: true, initialSize: 100, cellData: (ctx) => {
            return <div className="ad-account-domain">
                {ctx.row.original?.domain?.split?.(".")?.reduce?.((acc,val,ind,arr)=>(ind===0||ind===arr.length-1) ? acc+val?.toUpperCase?.() : acc,"")}
            </div>
        } },
        { columnKey: "groupName", header: t("active_directory.group_name"), showColumnVisibility: true, initialSize: 120 },
    ];
    const last5LoginActivityColumns = [
        { columnKey: "dateTime", header: t("active_directory.dateTime"), showColumnVisibility: true, initialSize: 120 },
        { columnKey: "requestId", header: t("active_directory.requestId"), showColumnVisibility: true, initialSize: 120 },
        { columnKey: "user", header: t("active_directory.user"), showColumnVisibility: true, initialSize: 120 },
        { columnKey: "application", header: t("active_directory.application"), showColumnVisibility: true, initialSize: 120 },
        { columnKey: "status", header: t("active_directory.status"), showColumnVisibility: true, initialSize: 120 }
    ];
    const [columns, setColumns]= useState([
        { columnKey: "id", header: t("active_directory.id"), showColumnVisibility: true, initialSize: 120 },
        { columnKey: "system", header: t("active_directory.system"), initialSize: 100 },
        { columnKey: "accountType", header: t("active_directory.type_of_account"), initialSize: 140, cellData: (ctx) => {
                return <div className="ad-account-type-of-account">
                    {ctx.row.original?.accountType}
                </div>
            } },
        { columnKey: "environment", header: t("active_directory.environment"), initialSize: 150 },
        {
            columnKey: "domain", header: t("active_directory.domain_label"), initialSize: 140, cellData: (ctx) => {
                return ctx.row.original?.domain ? <div className="ad-account-environment">
                    {ctx.row.original?.domain}
                </div> : null
            }
        },
        { columnKey: "lastPasswordChange", header: t("active_directory.last_password_change"), initialSize: 140 },
        { columnKey: "passwordExpiresOn", header: t("active_directory.password_expires_on"), initialSize: 140 },
        {
            columnKey: "isPartOfExceptionPolicy", header: t("active_directory.part_of_exception_policy"), initialSize: 110, cellData: (ctx) => {
                return <>{
                        ctx.row.original?.isPartOfExceptionPolicy ? 
                        <div className="ad-account-environment-mypamcompliant-yes">
                            {t("active_directory.yes")}
                        </div> :
                        <div className="ad-account-environment-mypamcompliant-no">
                            {t("active_directory.no")}
                        </div>
                    }
                </>
            }
        },
        {
            columnKey: "myPAMCompliant", header: t("active_directory.mypam_compliant"), initialSize: 110, cellData: (ctx) => {
                return <>{
                        ctx.row.original?.myPamCompliant?.toLowerCase?.() === 'non-compliant' ? 
                        <div className="ad-account-environment-mypamcompliant-no">
                            {t("active_directory.no")}
                        </div> 
                        : ctx.row.original?.myPamCompliant?.toLowerCase?.() === 'compliant' ? 
                        <div className="ad-account-environment-mypamcompliant-yes">
                            {t("active_directory.yes")}
                        </div> 
                        :
                        <div className="ad-account-environment-mypamcompliant">
                            {ctx.row.original?.myPamCompliant}
                        </div>
                    }
                </>
            }
        },
        {
            columnKey: "state", header: t("active_directory.state"), initialSize: 170, cellData: (ctx) => {
                return <>{
                    ctx.row.original?.state?.toLowerCase?.() === "unlocked" ? 
                    <div className="ad-account-state-unlocked">
                        <Icon
                            alt="alt value"
                            icon="lock_open"
                            size="18px"
                            className="ad-account-state-unlocked-icon"
                        />
                        <span className="text">{t("active_directory.unlocked")}</span>
                    </div> 
                    :
                    <div className="ad-account-state-locked">
                        <Icon
                            alt="alt value"
                            icon="lock"
                            size="18px"
                            className="ad-account-state-locked-icon"
                        />
                        <span className="text">{t("active_directory.locked")}</span>
                        {/* <button className="unlocked-btn" onClick={()=>unlockAccount(ctx.row.original)}>
                            <Icon
                                alt="alt value"
                                icon="lock_open"
                                size="18px"
                                className="unlocked-icon"
                            />
                            <span className="text">{t("active_directory.unlock")}</span>
                        </button> */}
                    </div>
                    }</>
            }
        },
        {
            columnKey: "azureSyncStatus", header: t("active_directory.azure_sync_status"), initialSize: 120, cellData: (ctx) => {
                return <>
                    {
                        ctx.row.original?.azureSyncStatus?.toLowerCase?.() === "inactive" ? 
                        <div className="ad-account-status-inactive">
                            {t("active_directory.inactive")}
                        </div> 
                        : 
                        <div className="ad-account-status-active">
                            {t("active_directory.active")}
                        </div>
                    }
                </>
            }
        },
        {
            columnKey: "status", header: t("active_directory.status"), initialSize: 90, cellData: (ctx) => {
                return <>
                    {
                        ctx.row.original?.status?.toLowerCase?.() === "inactive" ? 
                        <div className="ad-account-status-inactive">
                            {t("active_directory.inactive")}
                        </div> 
                        : 
                        <div className="ad-account-status-active">
                            {t("active_directory.active")}
                        </div>
                    }
                </>
            }
        },
        {
            columnKey: "", header: t("entraGuest.table_action"), initialSize: 165, enableSorting: false, cellData: (ctx) => {
                return <div className="d-flex action-column">
                    <div className="ad-account-action" onClick={()=>{
                        setSelectedGroupMemberships(ctx.row.original?.adGroupMemberships);
                        setSelectedAccountID(ctx.row.original?.id);
                        setShowSidePanel(true);
                    }}>
                        <Icon
                            alt="alt value"
                            icon="remove_red_eye"
                            size="18px"
                            className="ad-account-action-icon"
                        />
                        <span className="text">{t("homePage.view_details")}</span>
                    </div>
                    {
                        userProfile?.pepappiamcentralfeatures?.includes('ADExceptionPolicy') ? 
                        <div
                            style={{
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                position: 'relative'
                            }}
                        >
                            <Icon
                                alt="alt value"
                                icon="more_vert"
                                size="18px"
                                className="ml-2 ad-account-more-vertical-icon"
                                onClick={()=> {
                                    if(!(ctx.row.original?.accountType?.toLowerCase() === 'primary' && ctx.row.original?.isPartOfExceptionPolicy === undefined)){
                                        if(actionPopoverIDRef.current === ctx.row.original?.id) actionPopoverIDRef.current = "";
                                        else actionPopoverIDRef.current = ctx.row.original?.id;
                                    }
                                }}
                                disabled={ctx.row.original?.accountType?.toLowerCase() === 'primary' && ctx.row.original?.isPartOfExceptionPolicy === undefined}
                                style={{...((ctx.row.original?.accountType?.toLowerCase() === 'primary' && ctx.row.original?.isPartOfExceptionPolicy === undefined) && {cursor: "not-allowed"})}}
                            />
                            <div
                                style={{
                                left: isRtl ? '300%' : '-190%',
                                padding: '15px 0',
                                position: 'absolute',
                                ...(accountDataRef?.current?.find?.((acc)=>acc?.id === ctx.row.original?.id)?.popoverShowOnTop ? {bottom: '300%'} : {top: '110%'})
                                }}
                            >
                                <Popover
                                    badgeValue=""
                                    className=""
                                    direction="top-left"
                                    onClosePopover={()=> actionPopoverIDRef.current = ""}
                                    showSlot
                                    showPopover={actionPopoverIDRef?.current && actionPopoverIDRef.current === ctx.row.original?.id}
                                    style={{}}
                                >
                                    <div className="ad-account-more-vertical-popover" >
                                        <div className="d-flex">
                                            <Icon
                                                alt="alt value"
                                                icon={ctx.row.original?.isPartOfExceptionPolicy ? "keyboard_return" : "note_add"}
                                                size="18px"
                                                className=""
                                            />
                                            <div className="popover-text" onClick={()=> {
                                                setIsExceptionPolicyModal(!ctx.row.original?.isPartOfExceptionPolicy);
                                                setShowPolicyModal(true);
                                                setSelectedAccount(accountDataRef?.current?.find?.((acc)=>acc?.id === ctx.row.original?.id))
                                                actionPopoverIDRef.current = ""
                                            }}>{ctx.row.original?.isPartOfExceptionPolicy ? t("active_directory.move_back_to_standard_password_policy") : t("active_directory.request_for_exception_policy")}</div>
                                        </div>
                                        <Icon
                                            alt="alt value"
                                            icon="close"
                                            style={{fontSize: "20px"}}
                                            onClick={()=>actionPopoverIDRef.current = ""}
                                        />
                                    </div>
                                </Popover>
                            </div>
                        </div>
                        : null
                    }
                </div>
            }
        },
    ]);

    useEffect(()=>{
        const updatedAccountData = accountData.map((acc,i)=>({...acc, popoverShowOnTop:  ((i % pageSize) + 1) >= pageSize - 1}))
        setAccountData(updatedAccountData);
        accountDataRef.current = updatedAccountData;
    },[pageSize])

    const unlockAccount = async(data) => {
        showLoader();
        setLoader(true);
        try{
            const payload = {
                accountId: data?.id,
                domain: data?.domain,
                environment: data?.environment
            }
            const response = await axios.post(REACT_APP_API_ENDPOINT + "ad/unlockAccount", payload);
            if (response?.responseStatus === 'Success' || response?.status === 'Success') {
                const state = t("active_directory.unlocked");
                const updatedAccounts = accountData.map((rec)=>rec.id === data?.id ? {...rec, state} : rec);
                setAccountData(updatedAccounts);
                accountDataRef.current = updatedAccounts;
            }
            else {
                toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
            }
            hideLoader();
            setLoader(false);
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(e?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
        }
    }

    const fetchAccountInformation = async() => {
        showLoader();
        setLoader(true);
        try{
        
            const payload = { // this payload shpouldn't move on PROD
                fetchAllAccounts: true,
                fetchInactiveAccounts: true
            }
            const response = await axios.post(REACT_APP_API_ENDPOINT + "ad/myAccounts", payload);
            if (response?.data?.accounts) {
                if(response.data.accounts.length>0){
                    const updatedAccount = response.data.accounts.map((acc,i)=>({...acc, popoverShowOnTop: ((i % pageSize) + 1) >= pageSize - 1}));
                    setAccountData(updatedAccount);
                    accountDataRef.current = updatedAccount;
                }else{
                    toast.error( t("auditRequest.no_data_found_label"),"error");
                }
            }
            else {
                toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
            }
            hideLoader();
            setLoader(false);
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(e?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
        }
    }

    const fetchIDXAccountInformation = async() => {
        showLoader();
        setLoader(true);
        try{
        
            // const payload = { // this payload shpouldn't move on PROD
            //     fetchAllAccounts: true,
            //     fetchInactiveAccounts: true
            // }
            const response = await axios.post(REACT_APP_API_ENDPOINT + "idx/myAccounts");
            if (response?.data?.accounts) {
                if(response.data.accounts.length>0){
                    const updatedAccount = response.data.accounts.map((acc,i)=>({...acc, popoverShowOnTop: ((i % pageSize) + 1) >= pageSize - 1}));
                    setAccountData(updatedAccount);
                    accountDataRef.current = updatedAccount;
                }else{
                    toast.error( t("auditRequest.no_data_found_label"),"error");
                }
            }
            else {
                toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
            }
            hideLoader();
            setLoader(false);
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(e?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
        }
    }

    useEffect(() => {
        if(selectedTypeTabIndex === 0){
            setAccountData([]);
            fetchAccountInformation();
            setColumns(
                [
                    { columnKey: "id", header: t("active_directory.id"), showColumnVisibility: true, initialSize: 120 },
                    { columnKey: "system", header: t("active_directory.system"), initialSize: 100 },
                    { columnKey: "accountType", header: t("active_directory.type_of_account"), initialSize: 140, cellData: (ctx) => {
                            return ctx.row.original?.accountType ? <div className="ad-account-type-of-account">
                                {ctx.row.original?.accountType}
                            </div> : null
                        } },
                    { columnKey: "environment", header: t("active_directory.environment"), initialSize: 150 },
                    {
                        columnKey: "domain", header: t("active_directory.domain_label"), initialSize: 140, cellData: (ctx) => {
                            return ctx.row.original?.domain ? <div className="ad-account-environment">
                                {ctx.row.original?.domain}
                            </div> : null
                        }
                    },
                    { columnKey: "lastPasswordChange", header: t("active_directory.last_password_change"), initialSize: 140 },
                    { columnKey: "passwordExpiresOn", header: t("active_directory.password_expires_on"), initialSize: 140 },
                    {
                        columnKey: "isPartOfExceptionPolicy", header: t("active_directory.part_of_exception_policy"), initialSize: 110, cellData: (ctx) => {
                            return <>{
                                    ctx.row.original?.isPartOfExceptionPolicy ? 
                                    <div className="ad-account-environment-mypamcompliant-yes">
                                        {t("active_directory.yes")}
                                    </div> :
                                    <div className="ad-account-environment-mypamcompliant-no">
                                        {t("active_directory.no")}
                                    </div>
                                }
                            </>
                        }
                    },
                    {
                        columnKey: "myPAMCompliant", header: t("active_directory.mypam_compliant"), initialSize: 110, cellData: (ctx) => {
                            return <>{
                                    ctx.row.original?.myPamCompliant?.toLowerCase?.() === 'non-compliant' ? 
                                    <div className="ad-account-environment-mypamcompliant-no">
                                        {t("active_directory.no")}
                                    </div> 
                                    : ctx.row.original?.myPamCompliant?.toLowerCase?.() === 'compliant' ? 
                                    <div className="ad-account-environment-mypamcompliant-yes">
                                        {t("active_directory.yes")}
                                    </div> 
                                    :
                                    <div className="ad-account-environment-mypamcompliant">
                                        {ctx.row.original?.myPamCompliant}
                                    </div>
                                }
                            </>
                        }
                    },
                    {
                        columnKey: "state", header: t("active_directory.state"), initialSize: 170, cellData: (ctx) => {
                            return <>{
                                ctx.row.original?.state?.toLowerCase?.() === "unlocked" ? 
                                <div className="ad-account-state-unlocked">
                                    <Icon
                                        alt="alt value"
                                        icon="lock_open"
                                        size="18px"
                                        className="ad-account-state-unlocked-icon"
                                    />
                                    <span className="text">{t("active_directory.unlocked")}</span>
                                </div> 
                                :
                                <div className="ad-account-state-locked">
                                    <Icon
                                        alt="alt value"
                                        icon="lock"
                                        size="18px"
                                        className="ad-account-state-locked-icon"
                                    />
                                    <span className="text">{t("active_directory.locked")}</span>
                                    {/* <button className="unlocked-btn" onClick={()=>unlockAccount(ctx.row.original)}>
                                        <Icon
                                            alt="alt value"
                                            icon="lock_open"
                                            size="18px"
                                            className="unlocked-icon"
                                        />
                                        <span className="text">{t("active_directory.unlock")}</span>
                                    </button> */}
                                </div>
                                }</>
                        }
                    },
                    {
                        columnKey: "azureSyncStatus", header: t("active_directory.azure_sync_status"), initialSize: 120, cellData: (ctx) => {
                            return <>
                                {
                                    ctx.row.original?.azureSyncStatus?.toLowerCase?.() === "inactive" ? 
                                    <div className="ad-account-status-inactive">
                                        {t("active_directory.inactive")}
                                    </div> 
                                    : 
                                    <div className="ad-account-status-active">
                                        {t("active_directory.active")}
                                    </div>
                                }
                            </>
                        }
                    },
                    {
                        columnKey: "status", header: t("active_directory.status"), initialSize: 90, cellData: (ctx) => {
                            return <>
                                {
                                    ctx.row.original?.status?.toLowerCase?.() === "inactive" ? 
                                    <div className="ad-account-status-inactive">
                                        {t("active_directory.inactive")}
                                    </div> 
                                    : 
                                    <div className="ad-account-status-active">
                                        {t("active_directory.active")}
                                    </div>
                                }
                            </>
                        }
                    },
                    {
                        columnKey: "", header: t("entraGuest.table_action"), initialSize: 165, enableSorting: false, cellData: (ctx) => {
                            return <div className="d-flex action-column">
                                <div className="ad-account-action" onClick={()=>{
                                    setSelectedGroupMemberships(ctx.row.original?.adGroupMemberships);
                                    setSelectedAccountID(ctx.row.original?.id);
                                    setShowSidePanel(true);
                                }}>
                                    <Icon
                                        alt="alt value"
                                        icon="remove_red_eye"
                                        size="18px"
                                        className="ad-account-action-icon"
                                    />
                                    <span className="text">{t("homePage.view_details")}</span>
                                </div>
                                {
                                    userProfile?.pepappiamcentralfeatures?.includes('ADExceptionPolicy') ? 
                                    <div
                                        style={{
                                            alignItems: 'center',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            position: 'relative'
                                        }}
                                    >
                                        <Icon
                                            alt="alt value"
                                            icon="more_vert"
                                            size="18px"
                                            className="ml-2 ad-account-more-vertical-icon"
                                            onClick={()=> {
                                                if(!(ctx.row.original?.accountType?.toLowerCase() === 'primary' && ctx.row.original?.isPartOfExceptionPolicy === undefined)){
                                                    if(actionPopoverIDRef.current === ctx.row.original?.id) actionPopoverIDRef.current = "";
                                                    else actionPopoverIDRef.current = ctx.row.original?.id;
                                                }
                                            }}
                                            disabled={ctx.row.original?.accountType?.toLowerCase() === 'primary' && ctx.row.original?.isPartOfExceptionPolicy === undefined}
                                            style={{...((ctx.row.original?.accountType?.toLowerCase() === 'primary' && ctx.row.original?.isPartOfExceptionPolicy === undefined) && {cursor: "not-allowed"})}}
                                        />
                                        <div
                                            style={{
                                            left: isRtl ? '300%' : '-190%',
                                            padding: '15px 0',
                                            position: 'absolute',
                                            ...(accountDataRef?.current?.find?.((acc)=>acc?.id === ctx.row.original?.id)?.popoverShowOnTop ? {bottom: '300%'} : {top: '110%'})
                                            }}
                                        >
                                            <Popover
                                                badgeValue=""
                                                className=""
                                                direction="top-left"
                                                onClosePopover={()=> actionPopoverIDRef.current = ""}
                                                showSlot
                                                showPopover={actionPopoverIDRef?.current && actionPopoverIDRef.current === ctx.row.original?.id}
                                                style={{}}
                                            >
                                                <div className="ad-account-more-vertical-popover" >
                                                    <div className="d-flex">
                                                        <Icon
                                                            alt="alt value"
                                                            icon={ctx.row.original?.isPartOfExceptionPolicy ? "keyboard_return" : "note_add"}
                                                            size="18px"
                                                            className=""
                                                        />
                                                        <div className="popover-text" onClick={()=> {
                                                            setIsExceptionPolicyModal(!ctx.row.original?.isPartOfExceptionPolicy);
                                                            setShowPolicyModal(true);
                                                            setSelectedAccount(accountDataRef?.current?.find?.((acc)=>acc?.id === ctx.row.original?.id))
                                                            actionPopoverIDRef.current = ""
                                                        }}>{ctx.row.original?.isPartOfExceptionPolicy ? t("active_directory.move_back_to_standard_password_policy") : t("active_directory.request_for_exception_policy")}</div>
                                                    </div>
                                                    <Icon
                                                        alt="alt value"
                                                        icon="close"
                                                        style={{fontSize: "20px"}}
                                                        onClick={()=>actionPopoverIDRef.current = ""}
                                                    />
                                                </div>
                                            </Popover>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                        }
                    },
                ]
            )
        }else{
            setAccountData([]);
            fetchIDXAccountInformation();
            setColumns(
                [
                    { columnKey: "id", header: t("active_directory.id"), showColumnVisibility: true, initialSize: 120 },
                    { columnKey: "system", header: t("active_directory.system"), initialSize: 100, cellData: (ctx) => <div>IDX</div> },
                    { columnKey: "accountType", header: t("active_directory.type_of_account"), initialSize: 140, cellData: (ctx) => {
                            return ctx.row.original?.accountType? <div className="ad-account-type-of-account">
                                {ctx.row.original?.accountType}
                            </div>: null
                        } },
                    { columnKey: "environment", header: t("active_directory.environment"), initialSize: 150, cellData: (ctx) => <div>Non-Production</div> }, // for prod Production
                    // {
                    //     columnKey: "domain", header: t("active_directory.domain_label"), initialSize: 140, cellData: (ctx) => {
                    //         return ctx.row.original?.domain ?<div className="ad-account-environment">
                    //             {ctx.row.original?.domain}
                    //         </div> : null
                    //     }
                    // },
                    { columnKey: "lastPasswordChange", header: t("active_directory.last_password_change"), initialSize: 140 },
                    { columnKey: "passwordExpiresOn", header: t("active_directory.password_expires_on"), initialSize: 140 },
                    {
                        columnKey: "status", header: t("active_directory.status"), initialSize: 90, cellData: (ctx) => {
                            return <>
                                {
                                    ctx.row.original?.status?.toLowerCase?.() === "inactive" ? 
                                    <div className="ad-account-status-inactive">
                                        {t("active_directory.inactive")}
                                    </div> 
                                    : 
                                    <div className="ad-account-status-active">
                                        {t("active_directory.active")}
                                    </div>
                                }
                            </>
                        }
                    }
                ]
            )
        }
    }, [selectedTypeTabIndex])

    useEffect(()=>{
        const rowPerPageInputs = document.querySelectorAll(".active-directory-card-container #pagination .dropdown-wrapper input");
        rowPerPageInputs.forEach((el)=>{
            el.readOnly = true;
        })
    },[accountData,showSidePanel]);

    const closeModal = () => {
        setShowModal(false);
    }

    const onClickCopynumber = () => {
        if (requestData?.requestId) {
            navigator.clipboard.writeText(requestData?.requestId?.toString?.()).then(() => {
                setCopyButtonText(t('nonArExtension.copied'));
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        }
    };

    const onViewRequest = () => {
        const statePayload = { type: "requestNumber", value: requestData?.requestId};
        navigate("/audit-requests", { state: statePayload });
    }

    const renderConfirmModal = () => {
        return (
            <div className="confirm-modal">
                <Modal
                    showModal={showModal}
                    className="entra-request-success-modal"
                    onCloseModal={closeModal}
                    closeOnOutsideClick = {false}
                    notificationsProps={{
                        secondaryActionLabel: (
                            <>
                                <Icon
                                    alt="alt value"
                                    icon={copyButtonText == t('nonArExtension.copied') ? "check" : "content_copy"}
                                    size="medium"
                                    style={{ marginRight: '6px', display: 'unset' }}
                                />

                                {copyButtonText}
                            </>
                        ),
                        secondaryActionOnClick: onClickCopynumber,
                        text: `${requestData?.requestId}`,
                        title: t('nonArExtension.request_number_title'),
                        type: 'info'
                    }}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={true}
                    primaryButtonProps={{
                        onClick: onViewRequest,
                        size: 'medium',
                        text: t('homePage.view_request'),
                        variant: 'primary'
                    }}
                    showSecondaryButton={false}
                    showSlot
                    showTertiaryButton={true}
                    tertiaryButtonProps={{
                        onClick: closeModal,
                        size: 'medium',
                        text: t('nonArExtension.back'),
                        variant: 'tertiary'
                    }}
                    showCloseButton={true}
                    style={{}}
                    text={<>
                        <div style={{ marginTop: '10px'}}>
                        <p  className="modal-para-text">{t('entraGuest.entra_request_confirmation_text')} 
                        </p>
                        </div>
                    </>}
                    title={t('entraGuest.entra_request_confirmation_title')}
                    type="fluid"
                    viewPort={`${isMobile ? "mobile" : "desktop"}`}
                >
                    <p style={{fontSize:'16px'}} className="modal-para-text">{`${t('entraGuest.see_all_your_requests_in_the')} `} <span className="view-request-txt">{`${t('entraGuest.view_request')} `}</span> {t('entraGuest.section_below')} 
                    </p>
                </Modal>
            </div>
        )
    }

    const policyCard = (type, isCurrent, passCharLen) => {
        return <div className="policy-card">
            <div className="policy-type-container">
                <div className="policy-type">{type}</div>
                {isCurrent ? 
                    <div className="current-policy-tag">{t('active_directory.current')}</div> 
                    :
                    <div className="requested-policy-tag">{t('active_directory.requested')}</div>
                }
            </div>
            <div className="pass-length">{`${t('active_directory.minimum_password_length')}: ${passCharLen} ${t('active_directory.characters')}`}</div>
        </div>
    }

    const submitException = async() => {
        showLoader();
        setLoader(true);
        setShowPolicyModal(false);
        setBusinessJustification("");
        try{
            const payload = {
                typeOfAccount : selectedAccount?.accountType,
                domain : selectedAccount?.domain,
                accountName : selectedAccount?.id,
                endpointAccount : selectedAccount?.system?.toLowerCase() === "ad" ? "ACTIVE_DIRECTORY" : selectedAccount?.system,
                operation : selectedAccount?.isPartOfExceptionPolicy ? "REMOVE" : "ADD",
                businessJustification : businessJustification
            }
            const response = await activeDirectoryService.exceptionPolicy(payload);
            if (response?.responseStatus === 'Success' || response?.status === 'Success') {
                setShowModal(true);
                setRequestData(response);
            }
            else {
                toast.error(response?.errorMessage || t("entraGuest.request_fail_message"),"error");
            }
            hideLoader();
            setLoader(false);
        }catch(e){
            hideLoader();
            setLoader(false);
            toast.error(e?.response?.data?.errorMessage || t("auditRequest.something_went_wrong_label"),"error");
        }
    }

    const renderPolicyModal = () => {
        return (
            <div className="policy-modal">
                <Modal
                    showModal={showPolicyModal}
                    className="ad-policy-modal"
                    onCloseModal={()=>{
                        setShowPolicyModal(false);
                        setBusinessJustification("");
                    }}
                    closeOnOutsideClick = {false}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={true}
                    primaryButtonProps={{
                        onClick: submitException,
                        size: 'medium',
                        text: t('active_directory.submit'),
                        variant: 'primary',
                        disabled: businessJustification.length===0
                    }}
                    showSecondaryButton={false}
                    // showSlot
                    showTertiaryButton={true}
                    tertiaryButtonProps={{
                        onClick: ()=>{
                            setShowPolicyModal(false);
                            setBusinessJustification("");
                        },
                        size: 'medium',
                        text: t('active_directory.cancel'),
                        variant: 'tertiary'
                    }}
                    showCloseButton={true}
                    style={{}}
                    title={isExceptionPolicyModal ? t('active_directory.request_for_exception_policy') : t('active_directory.move_back_to_standard_password_policy')}
                    type="fluid"
                    viewPort={`${isMobile ? "mobile" : "desktop"}`}
                >
                    <p style={{fontSize:'16px'}} className="modal-para-text">
                        {isExceptionPolicyModal ? t('active_directory.request_for_exception_policy_Sub_Heading') : t('active_directory.move_back_to_standard_password_policy_Sub_Heading')}
                    </p>
                    <div className="modal-account-policy-container mb-2">
                        <div className="modal-account-container mb-2">
                            <div className="account-name">{`${t('active_directory.account')}: `}<strong>{selectedAccount?.id}</strong></div>
                        </div>
                        <div className="policy-cards-container">
                            {
                                policyCard(isExceptionPolicyModal ? t("active_directory.standard_policy") : t("active_directory.exception_policy"), true, isExceptionPolicyModal ? 25 : 15 )
                            }
                            {
                                policyCard(isExceptionPolicyModal ? t("active_directory.exception_policy") : t("active_directory.standard_policy"), false, isExceptionPolicyModal ? 15 : 25 )
                            }
                        </div>
                        {
                            isExceptionPolicyModal ? <div className="exception-info-container">
                                <Icon
                                    alt="alt value"
                                    icon="info"
                                    size="18px"
                                    className=""
                                />
                                <div className="exception-info-text">{t("active_directory.exception-info-text")}</div>
                            </div> : null
                        }
                    </div>
                    <TextArea
                        title={t("mypam.business_justification")}
                        label={t("mypam.business_justification")}
                        placeholder={t("idx.type_here")}
                        rows={3}
                        style={{ width: "100%"}}
                        onChange={(e) => setBusinessJustification(e.target.value)}
                        value={businessJustification}
                        showToolbar={false}
                        required={true}
                        showCharacterCount={true}
                        maxLength={500}
                        showLabelIcon={false}
                        disableResize={true}
                        className="exception-business-justification"
                    />
                </Modal>
            </div>
        )
    }

    const navigateOnOtherAD = () => {
        navigate("/other-active-directory", {state: {selectedTypeTabIndex}})
    }

    return (
        <div>
            <div
                className={isMobile ? "row" : "container"}
                style={{
                    background: "none",
                    boxShadow: "none",
                    justifyContent: isMobile ? "center" : "",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        flexDirection: isMobile ? "column" : "row",
                        gap: isMobile ? "0px" : "15px",
                        flexWrap: "wrap",
                        flex: 1,
                    }}
                >
                    <div className={isMobile ? "row mt-2" : ""} style={{ justifyContent: isMobile ? "center" : "" }}>
                        {/* <div className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : 'd-flex mb-0'}  align-items-center ad-main-heading-container`} style={{ gap: "12px" }}>
                            <ButtonIcon
                                className=""
                                color="Interaction/Active"
                                icon="arrow_backward"
                                label="Label"
                                onClick={()=>navigate(-1)}
                                size="medium"
                                style={{}}
                                type="default"
                            />
                            <div className="d-flex flex-column">
                                <div className="ad-main-heading">{t("active_directory.active_directory_dashboard")}</div>
                                <div className="ad-main-desc">{t("active_directory.view_your_account_information_and_activity")}</div>
                            </div>
                        </div> */}
                            <div
                            className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : ''} ad-main-heading-container`}
                        >
                            <Breadcrumb
                                homeIcon={{
                                    icon: "home",
                                    onClick:()=>{
                                    navigate("/home")
                                    }
                                }}
                                breadcrumbs={[
                                    {
                                        label: "Home",
                                    },
                                    {
                                        label: t("active_directory.active_directory_dashboard"),
                                    },
                                ]}
                                className="ad-breadcrumb"
                                useAnchor
                            />

                            <div className="ad-page-header">
                                <div className="ad-main-heading">
                                    {t("active_directory.active_directory_dashboard")}
                                </div>

                                <div className="ad-main-desc">
                                    {t("active_directory.view_your_account_information_and_activity")}
                                </div>
                            </div>
                        </div>
                        <div
                            className="card card-layout reg-card mb-3 mb-md-0 active-directory-card-container"
                            style={{
                                flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
                                width: isMobile ? "100%" : "auto",
                            }}
                        >
                            <div className="card-content align-items-center">
                                <div className="request-new-access-for-others-main-content h-100 m-0" style={{ width: '100% !important' }}>
                                    <div className="ad-table-header d-flex mb-3 justify-content-between align-items-center">
                                        {/* <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                            <ButtonIcon
                                                className="cursor-default"
                                                color="Interaction/Active"
                                                icon="account_circle"
                                                label="Label"
                                                onClick={function wRe() { }}
                                                size="medium"
                                                style={{}}
                                                type="default"
                                            />
                                            <div className="d-flex flex-column">
                                                <div className="ad-table-heading text-left">{t("active_directory.account_information")}</div>
                                                <div className="ad-table-desc">{t("active_directory.list_of_accounts_owned_by_you")}</div>
                                            </div>
                                        </div> */}
                                        <Switcher
                                            className=""
                                            items={[
                                                {
                                                    label: t("mypam.ad"),
                                                },
                                                {
                                                    label: t("mypam.idx"),
                                                },
                                            ]}
                                            selectedItemIndex={selectedTypeTabIndex}
                                            onUpdate={(n)=>{
                                                setSelectedTypeTabIndex(n);
                                            }}
                                            size="medium"
                                            style={{}}
                                            variant="default"
                                        />
                                        <div className="ad-other-account" onClick={navigateOnOtherAD}>
                                            {t('active_directory.other_account')}
                                            <Icon
                                                alt="alt value"
                                                icon="open_in_new"
                                                size="18px"
                                                className=""
                                            />
                                        </div>
                                    </div>
                                    <div style={{minHeight: "250px"}}>
                                        {accountData.length > 0 ? <DataTable
                                            className="datatable"
                                            columns={columns}
                                            key={i18n.language}
                                            enableSorting={true}
                                            data={accountData}
                                            pageIndex={pageIndex}
                                            pageSize={pageSize}
                                            onPageIndexChange={(index)=>setPageIndex(index)}
                                            onRowsPerPageChange={(size)=>setPageSize(size)}
                                            // searchPlaceholder={t("RequestGPIDForNonEmployee.search_placeholder")}
                                            selection="single"
                                            tableHeader="Data table header"
                                            size="large"
                                            showTableHeader={true}
                                            showTitle={true}
                                            showSearchOption={false}
                                            showColumnFilters={false}
                                            showDescription={false}
                                            tableDescription=""
                                            showPagination={true}
                                            noDataDescriptionText=""
                                        /> :
                                        <>
                                            {
                                                loader ? 
                                                null :
                                                <div className="ad-no-data-found-container d-flex justify-content-center m-auto">
                                                    <div className="no-data-found-content">
                                                        <div className="w-100 pt-4"><img src={serviceUnavailable} alt="Access required" className="mx-auto d-block" /></div>
                                                        <div className="no-data-found-main-heading">{t("active_directory.no_account_found")}</div>
                                                        <div className="no-data-found-sub-heading">{t("active_directory.no_account_found_sub_text")}</div>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {
                    showRiskySidepanel ? <Sidepanel
                    className="ad-sidepanel risky"
                    linkProps={{
                        iconLeading: '',
                        iconTrailing: 'arrow_forward',
                        label: 'Link',
                        onClick: function ERe() { },
                        size: 'medium'
                    }}
                    onCloseSidePanel={(event) => {
                        if (event.type == 'mousedown' || event.type == "mouseup") {
                            event.preventDefault();
                            return;
                        } 
                        setShowSidePanel(false)
                    }}
                    primaryButtonProps={{
                        onClick: function ERe() { },
                        size: 'medium',
                        text: t("active_directory.submit"),
                        variant: 'primary'
                    }}
                    

                    showSidePanel={showSidePanel}
                    secondaryButtonProps={{
                        onClick: function ERe() { },
                        size: 'medium',
                        text: t("active_directory.cancel"),
                        variant: 'secondary'
                    }}
                    showFooter={false}
                    showLink={false}
                    showSecondaryButton
                    showTertiaryButton={false}
                    style={{}}
                    closeOnOutsideClick={false}
                    tertiaryButtonProps={{
                        onClick: function ERe() { },
                        size: 'medium',
                        text: 'Button',
                        variant: 'tertiary'
                    }}
                    title={<span style={{fontSize: "22px"}}>{selectedAccountID}</span>}
                    type="vertical"
                    horizontalSidepanelWidth="70%"
                >
                    <Notification
                        customSecondaryActionButton={{
                            iconTrailing :"open_in_new"
                        }}
                        secondaryActionOnClick={() => { 
                                (
                                window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D&task.clear=1","_blank")
                                ) 
                            }
                        }
                        secondaryActionLabel={t("active_directory.raise_support_ticket")}
                        title={t("active_directory.risky_sign-on_detected")}
                        text={t("active_directory.suspicious_login_attempts_detected")}
                        type="error"
                        className="mb-2"
                    />
                    <TabsNavigation selectedIndex={selectedTabIndex} className="ad-sidepanel-tabs">
                        <Tab label={t("active_directory.ad_group_memberships")} onClick={() => setSelectedTabIndex(0)} />
                        <Tab label={t("active_directory.last_5_login_activity")} onClick={() => setSelectedTabIndex(1)} />
                    </TabsNavigation>
                    {
                        selectedTabIndex === 0 && <>
                            <DataTable
                                className="datatable"
                                columns={groupMembershipsColumns}
                                key={i18n.language}
                                enableSorting={true}
                                data={selectedGroupMemberships}
                                pageIndex={0}
                                pageSize={10}
                                // searchPlaceholder={t("RequestGPIDForNonEmployee.search_placeholder")}
                                selection="single"
                                tableHeader=""
                                size="large"
                                showTableHeader={true}
                                showTitle={true}
                                showSearchOption={false}
                                showColumnFilters={false}
                                showDescription={false}
                                tableDescription=""
                                showPagination={true}
                                noDataDescriptionText=""
                            />
                            <div className="ad-sidepanel-group-memberships-footer">
                                <span className="text">{t("active_directory.need_access_to_a_different_ad_group")}</span>
                                <span className="ad-sidepanel-raise-access" onClick={() => { 
                                    (
                                    window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D&task.clear=1","_blank")
                                    ) 
                                }}>
                                    {t("active_directory.raise_access")}
                                    <Icon
                                        alt="alt value"
                                        icon="open_in_new"
                                        size="18px"
                                        className=""
                                    />
                                </span>
                            </div>
                        </>
                    }
                    {
                        selectedTabIndex === 1 && 
                            <DataTable
                                className="datatable"
                                columns={last5LoginActivityColumns}
                                key={i18n.language}
                                enableSorting={true}
                                data={[]}
                                pageIndex={0}
                                pageSize={10}
                                // searchPlaceholder={t("RequestGPIDForNonEmployee.search_placeholder")}
                                selection="single"
                                tableHeader=""
                                size="large"
                                showTableHeader={true}
                                showTitle={true}
                                showSearchOption={false}
                                showColumnFilters={false}
                                showDescription={false}
                                tableDescription=""
                                showPagination={true}
                                noDataDescriptionText=""
                            />
                    }
                </Sidepanel> :
                <Sidepanel
                    className="ad-sidepanel hide-rows-per-page"
                    linkProps={{
                        iconLeading: '',
                        iconTrailing: 'arrow_forward',
                        label: 'Link',
                        onClick: function ERe() { },
                        size: 'medium'
                    }}
                    onCloseSidePanel={(event) => {
                        if (event.type == 'mousedown' || event.type == "mouseup") {
                            event.preventDefault();
                            return;
                        } 
                        setShowSidePanel(false)
                    }}
                    primaryButtonProps={{
                        onClick: function ERe() { },
                        size: 'medium',
                        text: t("active_directory.submit"),
                        variant: 'primary'
                    }}
                    

                    showSidePanel={showSidePanel}
                    secondaryButtonProps={{
                        onClick: function ERe() { },
                        size: 'medium',
                        text: t("active_directory.cancel"),
                        variant: 'secondary'
                    }}
                    showFooter={false}
                    showLink={false}
                    showSecondaryButton
                    showTertiaryButton={false}
                    style={{}}
                    closeOnOutsideClick={false}
                    tertiaryButtonProps={{
                        onClick: function ERe() { },
                        size: 'medium',
                        text: 'Button',
                        variant: 'tertiary'
                    }}
                    title={<span style={{fontSize: "22px"}}>{selectedAccountID}</span>}
                    type="vertical"
                    horizontalSidepanelWidth="40%"
                >
                    <div className="ad-group-memberships-heading">{t("active_directory.ad_group_memberships")}</div>
                    <DataTable
                        className="datatable"
                        columns={groupMembershipsColumns}
                        key={i18n.language}
                        enableSorting={true}
                        data={selectedGroupMemberships}
                        pageIndex={0}
                        pageSize={10}
                        // searchPlaceholder={t("RequestGPIDForNonEmployee.search_placeholder")}
                        selection="single"
                        tableHeader=""
                        size="large"
                        showTableHeader={true}
                        showTitle={true}
                        showSearchOption={false}
                        showColumnFilters={false}
                        showDescription={false}
                        tableDescription=""
                        showPagination={true}
                        noDataDescriptionText=""
                    />
                    <div className="ad-sidepanel-group-memberships-footer d-block">
                        <div className="text">{t("active_directory.need_access_to_a_different_ad_group")}</div>
                        <div className="ad-sidepanel-raise-access" onClick={() => { 
                            (
                            window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D&task.clear=1","_blank")
                            ) 
                        }}>
                            {t("active_directory.raise_access")}
                            <Icon
                                alt="alt value"
                                icon="open_in_new"
                                size="18px"
                                className=""
                            />
                        </div>
                    </div>
                </Sidepanel>
                }
                
            </div>
            <ToastContainer
                position="bottom-center"
            />
            {showModal && renderConfirmModal()}
            {showPolicyModal && renderPolicyModal()}
        </div>
    );
};

export default ActiveDirectory;
